import { Disposiciones_esp } from './../../../models/disposiciones_esp.model';
import { Component } from "@angular/core";
import {  FormControl, FormGroup, Validators } from '@angular/forms';
import { FormService } from 'src/app/services/form.service';

@Component({
    selector: "page-disposiciones_esp",
    templateUrl: "./disposiciones_especiales.component.html",
    styleUrls: ["./disposiciones_especiales.component.css"],
    providers: [FormService]
})

export class Disposiciones_espComponent {
      public rows = [];
      public actualRow;
      public disposiciones_esp: Disposiciones_esp;
      public form;
      public matcher = new FormService();
      public numberForm;
      public encontrado;

      constructor(){
        this.form = new FormGroup({
            disposicion1: new FormControl('', Validators.required),
            disposicion2: new FormControl('', Validators.required),
            disposicion3: new FormControl('', Validators.required),
            disposicion4: new FormControl('', Validators.required), 
            disposicion5: new FormControl('', Validators.required), 
            disposicion6: new FormControl('', Validators.required), 
            disposicion7: new FormControl('', Validators.required), 
            disposicion8: new FormControl('', Validators.required)            
        })
        if(!JSON.parse(localStorage.getItem("disposiciones_esp"))){
            localStorage.setItem("disposiciones_esp", JSON.stringify(this.rows));
        }else{
            this.rows = JSON.parse(localStorage.getItem("disposiciones_esp"));
            this.form.controls['disposicion1'].setValue(this.rows[0]?this.rows[0].disposicion1:false);
            this.form.controls['disposicion2'].setValue(this.rows[0]?this.rows[0].disposicion2:false);
            this.form.controls['disposicion3'].setValue(this.rows[0]?this.rows[0].disposicion3:false);
            this.form.controls['disposicion4'].setValue(this.rows[0]?this.rows[0].disposicion4:false);
            this.form.controls['disposicion5'].setValue(this.rows[0]?this.rows[0].disposicion5:false);
            this.form.controls['disposicion6'].setValue(this.rows[0]?this.rows[0].disposicion6:false);
            this.form.controls['disposicion7'].setValue(this.rows[0]?this.rows[0].disposicion7:false);
            this.form.controls['disposicion8'].setValue(this.rows[0]?this.rows[0].disposicion8:false);
        }

        this.disposiciones_esp = {disposicion1:'',disposicion2:'',disposicion3:'',disposicion4:'',disposicion5:'',disposicion6:'',disposicion7:'',disposicion8:''};
    
        if(localStorage.getItem("form")){
            this.numberForm = localStorage.getItem("form");
            if(this.numberForm == '2.5'){
                this.encontrado = true;
            }
        }
    }

    add_disposiciones_esp(){
        localStorage.setItem("disposiciones_esp",JSON.stringify([]));
        this.actualRow = localStorage.getItem("disposiciones_esp");
        this.rows = JSON.parse(this.actualRow);
        this.rows = this.rows.concat({
            disposicion1: this.form.value.disposicion1,
            disposicion2: this.form.value.disposicion2,
            disposicion3: this.form.value.disposicion3,
            disposicion4: this.form.value.disposicion4,
            disposicion5: this.form.value.disposicion5,
            disposicion6: this.form.value.disposicion6,
            disposicion7: this.form.value.disposicion7,
            disposicion8: this.form.value.disposicion8
        })
        localStorage.setItem("disposiciones_esp", JSON.stringify(this.rows));
    
    }

    delete_disposiciones_esp(id){
        for(let x = 0; x < this.rows.length; x++){
            if(id == x){
                this.rows.splice(x, 1);
                localStorage.setItem("disposiciones_esp", JSON.stringify(this.rows));
            }
        }
    }

}